import { createSlice } from "@reduxjs/toolkit";
import { useAppDispatch } from "../../hooks";
import { clearUserId } from "../users/userSlice";



const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    loginTime:null
  },
  reducers: {
    login(state,actions) {
      
      sessionStorage.setItem("Auth-Token", actions.payload);
       
      state.isAuthenticated = true;
    },
    logout(state) {
      sessionStorage.removeItem("Auth-Token");
      state.isAuthenticated = false;
      state.loginTime =null;
     
    },
    setLoginTime(state,action){
        state.loginTime = action.payload;
        
    }
  },
});

export const { login, logout, setLoginTime } = authSlice.actions;
export default authSlice.reducer;
